import { useFormik } from 'formik'
import React from 'react'
import { toast } from 'react-toastify'
import * as Yup from 'yup'

import { stripeAPI } from '../../api/services/stripe'
import { convertToShortDateFromSeconds } from '../../utils/formatter.ts'
import Button from '../common/Button/Button.tsx'
import Card from '../common/Card/Card.tsx'
import Input from '../common/forms/Input/Input.tsx'

const PayoutPopup = ({
  setIsPopupVisible,
  initialAmount,
  setRefetch
}: {
  setIsPopupVisible: React.Dispatch<React.SetStateAction<boolean>>
  initialAmount: number
  setRefetch: React.Dispatch<React.SetStateAction<number>>
}) => {
  const makePayoutAmount = async (amount: number) => {
    const toastId = toast.loading('Proszę czekać, trwa wysyłanie żądania')
    try {
      const response = await stripeAPI.create_payout({
        amount,
        currency: 'pln'
      })
      if (response.id) {
        setRefetch((prev) => prev + 1)
        const arrivalDate = convertToShortDateFromSeconds(response.arrival_date)
        toast.update(toastId, {
          render: `Środki zostały zlecone do wypłaty i powinny pojawić się na koncie w dniu ${arrivalDate}`,
          type: 'success',
          delay: 1000,
          isLoading: false,
          autoClose: 4000
        })
      }
    } catch {
      toast.dismiss(toastId)
    }
  }

  const validationSchema = Yup.object({
    amount: Yup.number()
      .typeError('Must be a valid number')
      .required('To pole jest wymagane')
      .min(5, 'Kwota nie może być mniejsza niż 5 pln')
      .max(initialAmount, 'Kwota nie może być większa od dostępnych środków')
      .test(
        'is-valid-amount',
        'Kwota musi posiadać dwa miejsca po przecinku',
        (value) => {
          if (isNaN(value)) return false
          const decimalMatch = value.toString().match(/^\d+(\.\d{1,2})?$/)
          if (!decimalMatch) return false
          return true
        }
      )
  })

  const formik = useFormik({
    initialValues: {
      amount: initialAmount.toFixed(2)
    },
    validationSchema,
    onSubmit: async (values) => {
      setIsPopupVisible(false)
      await makePayoutAmount(Math.round(parseFloat(values.amount) * 100))
    }
  })

  return (
    <div className="min-w-130">
      <Card className="border-0">
        <Card.Body>
          <h2 className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
            {'Wypłata środków'}
          </h2>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-1">
              <Input
                id="amount"
                name="amount"
                type="text"
                placeholder="Podaj kwotę do wypłaty"
                formik={formik}
                onChange={formik.handleChange}
              />
            </div>

            <div className="flex gap-2 mb-5">
              <Button
                variant="filled"
                fullWidth
                size="medium"
                color="danger"
                className="mb-3"
                // disabled={formik.isSubmitting}
                onClick={() => setIsPopupVisible(false)}
              >
                {'Anuluj'}
              </Button>
              <Button
                variant="filled"
                fullWidth
                size="medium"
                color="primary"
                type="submit"
                className="mb-3"
                // disabled={formik.isSubmitting}
              >
                {'Potwierdź'}
              </Button>
            </div>
          </form>
        </Card.Body>
      </Card>
    </div>
  )
}

export default PayoutPopup
